import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import Tag from '../Tag';
const RemovableTag = (_param)=>{
    var rest = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ React.createElement(Tag, _object_spread({
        postfix: /*#__PURE__*/ React.createElement(CloseIcon, {
            size: IconSize.TINY
        })
    }, rest));
};
RemovableTag.displayName = 'RemovableTag';
export default RemovableTag;

//# sourceMappingURL=RemovableTag.js.map